import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const names = ['María', 'Lucía', 'Roberto', 'Carlos', 'Fernanda', 'Valentina', 'Sofía', 'Mateo', 'Camila', 'Diego'];
const cities = ['Córdoba', 'Rosario', 'Buenos Aires', 'Mendoza', 'Tucumán', 'Santa Fe', 'La Plata', 'Salta', 'Mar del Plata', 'Neuquén'];
const products = ['Primaria', 'Secundaria', 'Pack Completo'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    product: '',
    time: 0
  });
  useEffect(() => {
    const showNotification = () => {
      const name = names[Math.floor(Math.random() * names.length)];
      const city = cities[Math.floor(Math.random() * cities.length)];
      const product = products[Math.floor(Math.random() * products.length)];
      const time = Math.floor(Math.random() * 10) + 1;
      setData({
        name,
        city,
        product,
        time
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialTimer = setTimeout(showNotification, 5000);
    const interval = setInterval(showNotification, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-23">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl border-l-4 border-coral p-4 pr-10 max-w-sm" data-id="element-24">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-25">
            <X size={16} data-id="element-26" />
          </button>
          <div className="flex items-start gap-3" data-id="element-27">
            <div className="bg-coral p-2 rounded-full text-white mt-1" data-id="element-28">
              <ShoppingBag size={20} data-id="element-29" />
            </div>
            <div data-id="element-30">
              <p className="text-sm text-purple-deep" data-id="element-31">
                <span className="font-bold" data-id="element-32">{data.name}</span> de{' '}
                <span className="font-bold" data-id="element-33">{data.city}</span> acaba de comprar
                el <span className="font-bold text-coral" data-id="element-34">{data.product}</span>
              </p>
              <p className="text-xs text-purple mt-1" data-id="element-35">
                hace {data.time} minutos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}